<template>
    <div class="permisos">
        <div>
            <vs-row>
                <vs-col class="cardInfo">
                    <menu-perfiles :hermanos="hermanos" :personaRol="personaRol" :personaId="personaId" @studentClicked="getAlumnoclicked" @alumnoName="getNameStudent"></menu-perfiles>
                </vs-col>
                <vs-col>
                    <descargar-materiales :personaId="personaId" :nameStudent="nameStudent"></descargar-materiales>
                </vs-col>
            </vs-row>
        </div>
    </div>
</template>
<script>
import MenuPerfiles from '../menu-perfiles/menu-perfiles.vue'
import DescargarMateriales from './descargar-materiales.vue'
export default {
    props: [
        'personaRol'
    ],
    data(){
        return{
            hermanos : [],
            alumnoClicked: {},
            personaId: '',
            nameStudent: '',
            loading: null,
        }
    },
    created(){
        let urlParams = new URLSearchParams(window.location.search);
        this.personaId = urlParams.get("persona_alumno_id");
    },
    components:{
        MenuPerfiles,
        DescargarMateriales
    },
    methods:{
        loadingPage(status){
            if(status){
                this.loading = this.$vs.loading()
            }else{
                this.loading.close()
            }
        },
        getNameStudent(nombreAlumno){
            this.nameStudent = nombreAlumno
        },
        getAlumnoclicked(user, programa){
            this.alumnoClicked = programa
            this.personaId = user.persona_id
            this.nameStudent = user.apellido_paterno + ' ' + user.apellido_materno + ' ' + user.nombres
        }
    }
}
</script>

<style scoped>
.cardInfo{
    background-color: #ffff;
    border-radius: 0 10px 10px 0;
    padding: 0.7rem 0.5rem 0.5rem 0.5rem;
}
</style>